import React from 'react';
import { CloseOutlined, MinusOutlined } from '@ant-design/icons';
import { WindowButton } from './WindowButton';

import './style.scss';

export interface WindowProps {
  header?: React.ReactNode;
  onClose?(): void;
  onCollapse?(): void;
  className?: string;
  style?: React.CSSProperties;
  children: JSX.Element;
  visible?: boolean;
}

// TODO: rename Dialog
export const Window = ({
  children,
  header,
  onClose,
  onCollapse,
  // TODO: Сейчас ширина и высота задаётся здесь. Возможно имеет смысл задавать его через props width и height. И позиционировать его относительно сайдбара
  className = '',
  style,
  visible,
}: WindowProps) => {
  return (
    <dialog
      open={visible === true}
      className={'window ' + className}
      style={style}
    >
      <div className="window-container">
        <div className="window__header">
          <div className="window__header-content">
            {header}

            <div className="window__buttons">
              {onCollapse && (
                <WindowButton
                  icon={<MinusOutlined />}
                  title="Скрыть"
                  onClick={onCollapse}
                />
              )}
              <WindowButton
                title="Закрыть"
                icon={<CloseOutlined />}
                onClick={onClose}
              />
            </div>
          </div>
        </div>

        <div className="window__body">{children}</div>
      </div>
    </dialog>
  );
};
